export enum DocumentTypeEnum {
  PROOF_OF_INCOME = "Proof of income",
  IMMIGRATION_STATUS = "Immigration Status",
  IMMIGRATION_DOCUMENT = "Immigration Document",
  SIGNATURE_PAGE = "Manual Account Signature Page",
  GOVERNMENT_ID = "Government Id",
  OTHER = "Other",
}
